import type { QueryClient } from "@tanstack/react-query";
import { updateDocumentLists } from "web_myplann/Api/Document/updateDocumentLists";

export const renameFolderInCache = (
	queryClient: QueryClient,
	previousTitle: string,
	title: string,
) =>
	updateDocumentLists(queryClient, (list) => ({
		...list,
		tags: list.tags.map((tag) =>
			tag.title === previousTitle ? { ...tag, title } : tag,
		),
	}));
